import React from "react";

import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "~/components/ui/tabs";
import { SalesChartProps } from "~/pages/purchase-orders/types/sales-notes";
import { formatCurrency } from "~/utils/helpers";

export const SalesChart: React.FC<SalesChartProps> = ({
  salesData,
  timePeriod,
  handleTimePeriodChange,
}) => {
  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">Evolución de Ventas</CardTitle>
          <Tabs
            defaultValue="daily"
            value={timePeriod}
            onValueChange={(value) => handleTimePeriodChange(value as any)}
            className="h-8"
          >
            <TabsList className="h-7">
              <TabsTrigger value="daily" className="h-5 px-2 text-xs">
                Diario
              </TabsTrigger>
              <TabsTrigger value="weekly" className="h-5 px-2 text-xs">
                Semanal
              </TabsTrigger>
              <TabsTrigger value="monthly" className="h-5 px-2 text-xs">
                Mensual
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="h-[250px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={salesData}
              margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="formattedDate"
                tick={{ fontSize: 10 }}
                interval={
                  timePeriod === "daily" ? (salesData.length > 30 ? 6 : 1) : 0
                }
              />
              <YAxis />
              <RechartsTooltip
                formatter={(value) => formatCurrency(value as number)}
                labelFormatter={(label) => `Fecha: ${label}`}
              />
              <Legend />
              <Area
                type="monotone"
                dataKey="sales"
                name="Ventas"
                stroke="#8884d8"
                fill="#8884d8"
                fillOpacity={0.3}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        {salesData.length === 0 && (
          <div className="flex h-40 items-center justify-center text-sm text-muted-foreground">
            No hay datos de ventas para el período seleccionado
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SalesChart;
